import { Component, effect, input } from '@angular/core';
import moment from 'moment';
import { catchError, map, Observable, of, take } from 'rxjs';
import { UserAreaContactMembershipModel } from '../../../../../models/user-area.model';
import { UserAreaService } from '../../../../../services/user-area.service';
import {
  TableColumn,
  Filter,
} from '../../../../shared-components/custom-table/custom-table.component';

@Component({
  selector: 'app-contact-member-areas',
  templateUrl: './contact-member-areas.component.html',
  styleUrl: './contact-member-areas.component.scss',
  standalone: false,
})
export class ContactMemberAreasComponent {
  userId = input<number>();

  public dataSource$: Observable<UserAreaContactMembershipModel[]> = of([]);
  public isLoading = true;

  constructor(private userAreaService: UserAreaService) {
    effect(() => {
      const id = this.userId();
      if (!id) {
        this.isLoading = false;
        this.dataSource$ = of([]);
        return;
      }
      this.loadMembershipAreas(id);
    });
  }

  private loadMembershipAreas(userId: number): void {
    this.isLoading = true;
    this.dataSource$ = this.userAreaService.getUserMembershipAreas(userId).pipe(
      take(1),
      map(memberships => {
        this.isLoading = false;
        return memberships;
      }),
      catchError(error => {
        console.error('Error fetching membership areas', error);
        this.isLoading = false;
        return of([]);
      })
    );
  }

  public columns: TableColumn[] = [
    {
      columnDef: 'areaName',
      header: 'Mitgliederbereich',
      sortable: true,
      width: '35%',
    },
    {
      columnDef: 'role',
      header: 'Rolle',
      sortable: true,
      width: '20%',
      filterValue: row => this.translateRole(row.role),
      render: row => this.translateRole(row.role),
    },
    {
      columnDef: 'joinedAt',
      header: 'Beigetreten am',
      sortable: true,
      width: '20%',
      filterValue: row =>
        row.joinedAt ? moment(row.joinedAt).format('DD.MM.YYYY') : '-',
      render: row =>
        row.joinedAt ? moment(row.joinedAt).format('DD.MM.YYYY') : '-',
    },
    {
      columnDef: 'areaMemberCount',
      header: 'Mitglieder',
      sortable: true,
      width: '15%',
      headerAlign: 'center',
      cellAlign: 'center',
      render: row =>
        row.areaMemberCount != null ? String(row.areaMemberCount) : '-',
    },
  ];

  public filters: Filter[] = [
    {
      filteredColumn: 'role',
      type: 'multiselect',
      label: 'Rolle',
      placeholder: 'Rolle auswählen...',
      selectOptions: [
        { value: 'OWNER', label: 'Eigentümer' },
        { value: 'ADMIN', label: 'Admin' },
        { value: 'MEMBER', label: 'Mitglied' },
      ],
    },
  ];

  private translateRole(role: string): string {
    if (role === 'OWNER') return 'Eigentümer';
    if (role === 'ADMIN') return 'Admin';
    return 'Mitglied';
  }
}
